import Vue from "vue";
import Router from "vue-router";
import VueAnalytics from 'vue-analytics';
import Middleware, * as Role from '@/services/middleware.js';

/**
 * Components
 */
import MainLayout from "@/components/layouts/Main";
import Index from "@/components/Index";
import Error from "@/components/Error";
/**
 * Account
 */
import AccountIndex from "@/components/account/Index";
import AccountPassword from "@/components/account/Password";
import AccountStudentLayout from "@/components/account/student/Layout";
import AccountStudentIndex from "@/components/account/student/Index";
import AccountStudentProfile from "@/components/account/student/Profile";
import AccountStudentScore from "@/components/account/student/Score";
import AccountStudentAttend from "@/components/account/student/Attend";
import AccountStudentPsychoTest from "@/components/account/student/PsychoTest";
import AccountStudentUTBK from "@/components/account/student/UTBK";
import AccountStudentTryoutView from "@/components/account/student/tryout/View";
import AccountStudentTryoutViewEHB from "@/components/account/student/tryout/ViewEHB";
import AccountStudentRecommendationIndex from "@/components/account/student/recommendation/Index";

import AccountEmployeeIndex from "@/components/account/employee/Index";

/**
 * Product
 */
import ProductIndex from "@/components/product/Index";
import ProductRegistration from "@/components/product/Registration";

/**
 * Tryout
 */
import TryoutIndex from "@/components/tryout/Index";
import TryoutView from "@/components/tryout/View";
import TryoutQuestionView from "@/components/tryout/question/View";

/**
 * Recommendation
 */
import ProgramStudyIndex from "@/components/program-study/Index";
import ProgramStudyView from "@/components/program-study/View";

/**
 * Material
 */
import MaterialIndex from "@/components/material/Index";
import MaterialView from "@/components/material/View";

/**
 * Schedule
 */
import ScheduleIndex from "@/components/schedule/Index";

/**
 * Forum
 */
import ForumIndex from "@/components/forum/Index";
import ForumSubject from "@/components/forum/Subject";
import ForumCategory from "@/components/forum/Category";
import ForumThreadIndex from "@/components/forum/thread/Index";
import ForumThreadAdd from "@/components/forum/thread/Add";
import ForumThreadView from "@/components/forum/thread/View";
import ForumThreadEdit from "@/components/forum/thread/Edit";
import ForumThreadCommentEdit from "@/components/forum/thread/comment/Edit";

/**
 * Article
 */
import ArticleIndex from "@/components/article/Index";
import ArticleView from "@/components/article/View";

/**
 * Static
 */
import StaticAbout from "@/components/static/About";
import StaticContact from "@/components/static/Contact";

Vue.use(Router);

const router = new Router({
    mode: "history",
    linkExactActiveClass: "active",
    routes: [
        {
            path: "", component: MainLayout, children: [
                {path: "/", name: "index", component: Index},
                /**
                 * Account
                 */
                {
                    path: "/account", name: "account/index", component: AccountIndex, beforeEnter: Middleware.authentication, redirect: () => {
                        var roles = {student: Role.STUDENT, employee: Role.EMPLOYEE};
                        for (var role in roles) {
                            if (Role.has(roles[role])) {
                                return {name: 'account/' + role + '/index'};
                            }
                        }
                        return {name: 'index'};
                    }, children: [
                        /**
                         * Student
                         */
                        {
                            path: "/account/student", component: AccountStudentLayout, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication, children: [
                                {path: "", name: "account/student/index", component: AccountStudentIndex, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                {path: "/account/student/profile", name: "account/student/profile", component: AccountStudentProfile, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                {path: "/account/student/score", name: "account/student/score", component: AccountStudentScore, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                {path: "/account/student/attend", name: "account/student/attend", component: AccountStudentAttend, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                {path: "/account/student/psycho-test", name: "account/student/psycho-test", component: AccountStudentPsychoTest, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                {path: "/account/student/utbk", name: "account/student/utbk", component: AccountStudentUTBK, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                /**
                                 * Tryout
                                 */
                                {path: "/account/student/tryout/:id", name: "account/student/tryout/view", component: AccountStudentTryoutView, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
				/**
                                 * TryoutEHB
                                 */
                                {path: "/account/student/tryout/:id", name: "account/student/tryout/viewEHB", component: AccountStudentTryoutViewEHB, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                                /**
                                 * Recommendation
                                 */
                                {path: "/account/student/recommendation/:type", name: "account/student/recommendation/index", component: AccountStudentRecommendationIndex, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication}
                            ]
                        },
                        {path: "/account/password", name: "account/password", component: AccountPassword, beforeEnter: Middleware.authentication},
                        /**
                         * Employee
                         */
                        {path: "/account/employee", name: "account/employee/index", component: AccountEmployeeIndex, meta: {roles: [Role.EMPLOYEE]}, beforeEnter: Middleware.authentication}
                    ]
                },
                /**
                 * Tryout
                 */
                {path: "/tryout", name: "tryout/index", component: TryoutIndex, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                {path: "/tryout/:id", name: "tryout/view", component: TryoutView, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                {path: "/tryout/:id/un/:tryoutSubjectID(\\d+)", name: "tryout/question/view", component: TryoutQuestionView, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                {path: "/tryout/:id/ptn/:tryoutGroupID(\\d+)", name: "tryout/question/view-group", component: TryoutQuestionView, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                /**
                 * Recommendation
                 */
                {path: "/program-study/:type", name: "program-study/index", component: ProgramStudyIndex, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                {path: "/program-study/:type/:id(\\d+)", name: "program-study/view", component: ProgramStudyView, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                /**
                 * Material
                 */
                {path: "/material", name: "material/index", component: MaterialIndex, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                {path: "/material/:id", name: "material/view", component: MaterialView, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                /**
                 * Schedule
                 */
                {path: "/schedule", name: "schedule/index", component: ScheduleIndex, meta: {roles: [Role.STUDENT]}, beforeEnter: Middleware.authentication},
                /**
                 * General Page
                 */
                
                {path: "/product/registration/:id(\\d+)", name: "product/registration", component: ProductRegistration},
                /**
                 * Forum
                 */
                {path: "/forum", name: "forum/index", component: ForumIndex, beforeEnter: Middleware.authentication},
                {path: "/forum/grade/:id(\\d+)", name: "forum/subject", component: ForumSubject, beforeEnter: Middleware.authentication},
                {path: "/forum/subject/:id(\\d+)", name: "forum/category", component: ForumCategory, beforeEnter: Middleware.authentication},
                {path: "/forum/category/:id(\\d+)", name: "forum/thread/index", component: ForumThreadIndex, beforeEnter: Middleware.authentication},
                {path: "/forum/category/:id(\\d+)/add", name: "forum/thread/add", component: ForumThreadAdd, meta: {roles: [Role.ADMIN, Role.STUDENT, Role.EMPLOYEE_DIRECTOR, Role.EMPLOYEE_MANAGER]}, beforeEnter: Middleware.authentication},
                {path: "/forum/thread/:id(\\d+)", name: "forum/thread/view", component: ForumThreadView, beforeEnter: Middleware.authentication},
                {path: "/forum/thread/:id(\\d+)/edit", name: "forum/thread/edit", component: ForumThreadEdit, beforeEnter: Middleware.authentication},
                {path: "/forum/comment/:id(\\d+)/edit", name: "forum/thread/comment/edit", component: ForumThreadCommentEdit, beforeEnter: Middleware.authentication},
                /**
                 * Article
                 */
                {path: "/article", name: "article/index", component: ArticleIndex},
                {path: "/article/:id(\\d+)", name: "article/view", component: ArticleView},
                /**
                 * Static
                 */
		{path: "/product", name: "product/index", component: ProductIndex},
                {path: "/about", name: "static/about", component: StaticAbout},
                {path: "/contact", name: "static/contact", component: StaticContact},
                /**
                 * Error Page
                 */
                {path: "/error", name: "error", component: Error, props: true}
            ]
        },
        /**
         * Catch undefined route to error page
         */
        {path: "*", redirect: {name: 'error', params: {code: 404, message: "Page Not Found"}}}
    ]
});

/**
 * Google Analytics
 */
Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS_TRACKING_ID,
    router,
    ignoreRoutes: ['error'],
    autoTracking: {
        pageviewTemplate(route) {
            return {
                page: route.path,
                title: document.title,
                location: window.location.href
            };
        }
    },
    debug: {
        enabled: process.env.NODE_ENV !== 'production',
        sendHitTask: process.env.NODE_ENV === 'production'
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js